<script lang="ts" setup>
interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  margin?: string;
}

const props = defineProps<SkeletonProps>();

const skeletonStyles = computed(() => ({
  width: props.width ?? '100%',
  height: props.height ?? '20px',
  borderRadius: props.borderRadius ?? '4px',
  margin: props.margin ?? '0',
}));
</script>

<template>
  <div class="skeleton" :style="skeletonStyles"></div>
</template>

<style scoped>
.skeleton {
  background-color: #e0e0e0;
  animation: skeleton-loading 1.2s infinite;
}

@keyframes skeleton-loading {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #c0c0c0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
</style>
